import {
  LIST_EMPLOYMENT_CONTRACT_API,
  TYPE_EMPLOYMENT_CONTRACT_API,
  SETTING_EMPLOYMENT_CONTRACT_API,
  HRM_EMPLOYMENT_CONTRACT_API,
  UPDATE_SETTING_CONTRACT_API,
  CREATE_TYPE_CONTRACT_API,
  UPDATE_TYPE_CONTRACT_API,
  DELETE_TYPE_CONTRACT_API,
  UPDATE_EMPLOYMENT_CONTRACT_API,
  DELETE_EMPLOYMENT_CONTRACT_API,
  CREATE_EMPLOYMENT_CONTRACT_API,
  GET_CONTRACT_BY_ID_API,
  STOP_EMPLOYMENT_CONTRACT_API,
  ECONTRACT_TYPE_SETTING_API,
  ECONTRACT_TYPE_SETTING_UPSERT_API,
  ECONTRACT_TYPE_SETTING_DELETE_API,
  CONTRACT_API,
} from "constants/ApiConstant";
import axiosInstance from "auth/FetchInterceptor";
const employmentContractService = {};

employmentContractService.GetSettingContract = function () {
  return axiosInstance.get(`${SETTING_EMPLOYMENT_CONTRACT_API}`);
};
employmentContractService.GetTypeContract = function () {
  return axiosInstance.get(`${TYPE_EMPLOYMENT_CONTRACT_API}`);
};
employmentContractService.GetHRMContract = function () {
  return axiosInstance.get(`${HRM_EMPLOYMENT_CONTRACT_API}`);
};
employmentContractService.UpdateSettingContract = function (data) {
  return axiosInstance.post(`${UPDATE_SETTING_CONTRACT_API}`, data);
};

employmentContractService.UpdateContractType = function (data) {
  return axiosInstance.put(`${UPDATE_TYPE_CONTRACT_API}`, data);
};
employmentContractService.CreateContractType = function (data) {
  return axiosInstance.post(`${CREATE_TYPE_CONTRACT_API}`, data);
};
employmentContractService.DeleteContractType = function (data) {
  return axiosInstance.delete(`${DELETE_TYPE_CONTRACT_API}?id=${data}`);
};

employmentContractService.GetContractList = function (data) {
  return axiosInstance.post(`${LIST_EMPLOYMENT_CONTRACT_API}`, data);
};
employmentContractService.UpdateContractList = function (data) {
  return axiosInstance.put(`${UPDATE_EMPLOYMENT_CONTRACT_API}`, data);
};
employmentContractService.DeleteContract = function (data) {
  return axiosInstance.delete(`${DELETE_EMPLOYMENT_CONTRACT_API}?id=${data}`);
};
employmentContractService.DeleteEContract = function (id) {
  return axiosInstance.delete(`${CONTRACT_API}/delete-econtract-byid?ContractId=${id}`);
};
employmentContractService.StopContract = function (data) {
  return axiosInstance.put(`${STOP_EMPLOYMENT_CONTRACT_API}`, data);
};

employmentContractService.CreateContractList = function (data) {
  return axiosInstance.post(`${CREATE_EMPLOYMENT_CONTRACT_API}`, data);
};

employmentContractService.GetContractById = function (data) {
  return axiosInstance.get(`${GET_CONTRACT_BY_ID_API}?id=${data}`);
};

employmentContractService.GetEcontractTypeSetting = function (loaiHopDongId) {
  return axiosInstance.get(`${ECONTRACT_TYPE_SETTING_API}?loaiHopDongId=${loaiHopDongId}`);
};
employmentContractService.UpsertEcontractTypeSetting = function (data) {
  return axiosInstance.post(ECONTRACT_TYPE_SETTING_UPSERT_API, data);
};
employmentContractService.DeleteEcontractTypeSetting = function (id) {
  return axiosInstance.delete(`${ECONTRACT_TYPE_SETTING_DELETE_API}?SettingId=${id}`);
};

employmentContractService.importTempContract = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/upload-contract-type-temp/${data.keyId}`, data.importFile, { ContentType: "multipart/form-data", });
};
employmentContractService.GetDanhSachCotDong = function (id) {
  return axiosInstance.get(`${CONTRACT_API}/get-danhsach-cotdong`);
};

//------> E Contract

employmentContractService.getEContractList = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/getall-econtract`, data);
};
employmentContractService.upsertEcontract = function (data) {
  return axiosInstance.put(`${CONTRACT_API}/upsert-econtract`, data);
};
employmentContractService.getEContractById = function (data) {
  return axiosInstance.get(`${CONTRACT_API}/get-econtract-byid?ContractId=${data}`);
};

employmentContractService.ViewPdfContract = function (data) {
  return axiosInstance.get(`${CONTRACT_API}/view-pdf-contract?ContractId=${data}`);
};
employmentContractService.EContractSigedAction = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/update-e-contract-sign`, data);
};
employmentContractService.GetEContractSiged = function (data) {
  return axiosInstance.get(`${CONTRACT_API}/get-econtract-sign?ContractId=${data}`);//get-econtract-sign
};
employmentContractService.SetEcontractSignedViTri = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/set-e-contract-sign-vitri`, data);
};

// employmentContractService.XuatEContract = function (data) {
//   return axiosInstance.get(`${CONTRACT_API}/tao-econtract-hdmau-vnpt?ContractId=${data}`);
// };

employmentContractService.XuatEContract = function (data) {
  const { ContractId, branchId, loaiTaiLieuId } = data;
  const branchParam = branchId ? `&branchId=${branchId}` : "";
  const loaiTaiLieuParam =
    loaiTaiLieuId !== undefined && loaiTaiLieuId !== null && loaiTaiLieuId !== ""
      ? `&loaiTaiLieuId=${loaiTaiLieuId}`
      : "";
  return axiosInstance.get(`${CONTRACT_API}/tao-econtract-vnpt-upload?ContractId=${ContractId}${branchParam}${loaiTaiLieuParam}`);
};
employmentContractService.DanhMucLoaiTaiLieuVnpt = function (branchId) {
  const branchParam = branchId ? `?branchId=${branchId}` : "";
  return axiosInstance.get(`${CONTRACT_API}/get-dm-loai-tai-lieu-vnpt${branchParam}`);
};
employmentContractService.UploadEContractList = function (data) {
  return axiosInstance.get(`${CONTRACT_API}/upload-list-contract?transId=${data}`);
};
employmentContractService.exportDefaultEContract = function (data) {
  const branchParam = data?.branchId ? `&branchId=${data.branchId}` : "";
  return axiosInstance.get(
    `${CONTRACT_API}/export-default-econtract?loaiHopDongId=${data.loaiHopDongId}${branchParam}`
  );
};
employmentContractService.TaiEContract = function (data) {
  const { contractId, branchId } = data;
  const branchParam = branchId ? `&branchId=${branchId}` : "";
  return axiosInstance.get(`${CONTRACT_API}/tai-econtract-vnpt?ContractId=${contractId}${branchParam}`);
};
employmentContractService.GuiHdChoCacBenKy = function (data) {
  const { contractId, branchId } = data;
  const branchParam = branchId ? `&branchId=${branchId}` : "";
  return axiosInstance.get(`${CONTRACT_API}/gui-hd-cac-ben-ky?ContractId=${contractId}${branchParam}`);
};
employmentContractService.DongBoTrangThaiKy = function (data) {
  const { contractId, branchId } = data;
  const branchParam = branchId ? `&branchId=${branchId}` : "";
  return axiosInstance.get(`${CONTRACT_API}/dong-bo-trang-thai-ky?ContractId=${contractId}${branchParam}`);
};
// Ký SmartCA hàng loạt cho các vị trí SmartCA (không phải USB Token) chưa ký của hợp đồng.
employmentContractService.KySmartCaTatCa = function (data) {
  const { contractId, branchId } = data;
  const branchParam = branchId ? `&branchId=${branchId}` : "";
  return axiosInstance.get(`${CONTRACT_API}/ky-smartca-tat-ca?ContractId=${contractId}${branchParam}`);
};
// Đồng bộ trạng thái + file preview VNPT cho tất cả HĐ đang ký dở (giống job nền chạy 5'/lần).
employmentContractService.DongBoTrangThaiKyTatCa = function () {
  return axiosInstance.get(`${CONTRACT_API}/dong-bo-trang-thai-ky-tat-ca`);
};
// Kiểm tra đăng nhập eContract VNPT với tài khoản/mật khẩu nhập ở màn cơ cấu tổ chức.
employmentContractService.KiemTraDangNhapEContract = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/kiem-tra-dang-nhap-econtract`, data);
};
// v3: Upload tạo hợp đồng từ mẫu VNPT - lấy vị trí ký từ mẫu
employmentContractService.TaoHopDongVNPT_TuHdMau = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/tao-hopdog-tu-mau`, data);
};
// Lưu tài khoản eContract VNPT của nhân viên (tab eContract màn nhân viên)
employmentContractService.LuuTaiKhoanEContractNhanVien = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/luu-tk-econtract-nhanvien`, data);
};
// Lưu tài khoản eContract VNPT của chi nhánh (tab eContract màn cơ cấu tổ chức)
employmentContractService.LuuTaiKhoanEContractChiNhanh = function (data) {
  return axiosInstance.post(`${CONTRACT_API}/luu-tk-econtract-chinhanh`, data);
};
export default employmentContractService;
